export default __webpack_public_path__ + "static/media/icon-levelcard-bg.103fceb5.svg";